import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-fzunterklasse-list-view',
  imports: [],
  templateUrl: './fzunterklasse.list-view.html',
  styleUrls: ['./fzunterklasse.list-view.css'],
})
export class FzunterklasseListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
